import PictureAsPdf from '../../assets/icons/picture_as_pdf.svg';
import DocIcon from '../../assets/icons/doc-icon.svg';
import Separator from '../globals/separator';

export const ControlDownloadResource = ({isDonwloadResource,onExportToWord,cleanedContent,onDownloadPDF, docTitle = null }) => {
    if(!isDonwloadResource || !onExportToWord || !onDownloadPDF) return null;
    return <>
      <Separator />
      <div className='w-full flex flex-col gap-4'>
        <div
          id='edit-section'
          className='flex justify-evenly gap-2 mt-6'
        >
          <div
            id='word-button-container'
            className='cursor-pointer text-Yellow-500'
            onClick={() => onExportToWord(cleanedContent, docTitle)}
          >
            <img className='h-10 w-10' src={DocIcon} alt='word' />
            <button id='word'>Word</button>
          </div>
  
          <div
            id='pdf-button-container'
            className='cursor-pointer text-Yellow-500'
            onClick={() => onDownloadPDF(cleanedContent, docTitle)}
          >
            <img
              className='h-10 w-10'
              src={PictureAsPdf}
              alt='pdf'
            />
            <button id='pdf'>PDF</button>
          </div>
        </div>
      </div>
    </>
  }